import {KeyService} from '@/services/KeyService'
import {VesselService} from '@/services/VesselService'
import {DataService} from '@/services/DataService'
import axios from "axios";
import {DELETE_VESSEL, DOWNLOAD_STATUS_HISTORY} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";

const state = {
  vesselTypeKeys: [],
  vesselKeys: [],
  vesselList: [],
  vessel: {},
  vesselInfo: {},
  vesselManagement : {},
  vesselAccidentIncidentYearlyCounts : [],
  vesselAccidentIncidentYearlyCountsList : [],
  vesselAccidentIncidentWorkingEnvironments : [],
  vesselAccidentIncidentWorkingEnvironmentsSummary : [],
  vesselSummaryList : [],
  vesselPscInspectionDeficiencies: [],
  vesselPscInspectionInspections: [],
  vesselRightshipInspectionInspections: [],
  vesselManningCompanyList: [],
  vesselsAuditSchedule : []
}

const mutations = {
  setVesselManagement : (state, vesselManagement) => state.vesselManagement = vesselManagement,
  // eslint-disable-next-line no-return-assign
  setVesselTypeKeys: (state, vesselTypeKeys) => state.vesselTypeKeys = vesselTypeKeys,
  // eslint-disable-next-line no-return-assign
  setVesselKeys: (state, vesselKeys) => state.vesselKeys = vesselKeys,
  // eslint-disable-next-line no-return-assign
  setVesselList: (state, vesselList) => state.vesselList = vesselList,
  setVesselsAuditSchedule: (state, vesselsAuditSchedule) => state.vesselsAuditSchedule = vesselsAuditSchedule,
  // eslint-disable-next-line no-return-assign
  setVessel: (state, vessel) => state.vessel = vessel,

  removeVessel: (state,vesselId)=> {
    let index=state.vesselList.findIndex(vessel=>vessel.id===vesselId);
    if(index >= 0){
      state.vesselList.splice(index,1);
    }
  },

  setVesselInfo: (state, vesselInfo) => state.vesselInfo = vesselInfo,
  setVesselAccidentIncidentYearlyCounts: (state, vesselAccidentIncidentYearlyCounts) => state.vesselAccidentIncidentYearlyCounts = vesselAccidentIncidentYearlyCounts,
  setVesselAccidentIncidentYearlyCountsList: (state, vesselAccidentIncidentYearlyCountsList) => state.vesselAccidentIncidentYearlyCountsList = vesselAccidentIncidentYearlyCountsList,
  setVesselAccidentIncidentWorkingEnvironments: (state, vesselAccidentIncidentWorkingEnvironments) => state.vesselAccidentIncidentWorkingEnvironments = vesselAccidentIncidentWorkingEnvironments,
  setVesselAccidentIncidentWorkingEnvironmentsSummary: (state, vesselAccidentIncidentWorkingEnvironments) => state.vesselAccidentIncidentWorkingEnvironmentsSummary = vesselAccidentIncidentWorkingEnvironments,
  setPscInspectionDeficiencies: (state, vesselPscInspectionDeficiencies) => state.vesselPscInspectionDeficiencies = vesselPscInspectionDeficiencies,
  setPscInspectionInspections: (state, vesselPscInspectionInspections) => state.vesselPscInspectionInspections = vesselPscInspectionInspections,
  setRightshipInspectionInspections: (state, vesselRightshipInspectionInspections) => state.vesselRightshipInspectionInspections = vesselRightshipInspectionInspections,
  setVesselSummaryList: (state, vesselSummaryList) => state.vesselSummaryList = vesselSummaryList,
  setAllVesselManningCompany: (state, vesselManningCompanyList) => state.vesselManningCompanyList = vesselManningCompanyList,
}

const actions = {
  async getDashboardVesselManagement({commit}) {
    const vesselManagement = await VesselService.getDashboardVesselManagement()
    if (vesselManagement) commit('setVesselManagement', vesselManagement)
  },
  async getVesselSummaryList({commit}, params) {
    let vesselSummaryList = await VesselService.getVesselSummaryList(params);
    if (vesselSummaryList) commit('setVesselSummaryList', vesselSummaryList);
  },
  async getVesselTypeKeys({commit}) {
    const vesselTypeKeys = await KeyService.getVesselTypeKeys()
    if (vesselTypeKeys) commit('setVesselTypeKeys', vesselTypeKeys)
  },
  async getVesselKeys({commit}) {
    const vesselKeys = await KeyService.getVesselKeys()
    if (vesselKeys) commit('setVesselKeys', vesselKeys)
  },
  async getVessels({commit}, params) {
    let vesselList = await VesselService.getVesselList(params)
    if (vesselList){
      commit('setVesselList', vesselList.data)
      commit('setPagination',vesselList)
    }
  },
  async getVesselsAuditSchedule({commit}, params) {
    let vesselList = await VesselService.getVesselsAuditSchedule(params);
    if (vesselList){
      commit('setVesselsAuditSchedule', vesselList.data)
      commit('setPagination',vesselList)
    }
  },
  async updateVesselAuditSchedule({commit}, params) {
    return await VesselService.updateVesselAuditSchedule(params);
  },
  async getVesselDetail({commit}, vesselId) {
    commit('setVessel', {})
    const vessel = await VesselService.getVesselDetail(vesselId)
    if (vessel) commit('setVessel', vessel)
  },

  async getVesselInfo({ commit }, params) {
    commit('setVesselInfo', {})
    let vesselInfo = await VesselService.getVesselInfo(params);
    if(vesselInfo) commit('setVesselInfo', vesselInfo);
  },

  async updateVessel({commit}, params) {
    const updatedVessel = await VesselService.updateVessel(params);
    if (updatedVessel) commit('setVesselInfo', updatedVessel)
  },

  async deleteVessel({commit},params){
    return await axios.post(DELETE_VESSEL,params).then(response => {
      if (response.hasOwnProperty('status') && response.status === 200) {
        return true;
      }
      return response;
    }).catch(error => {
      if(error.response.status === 500){
        GlobalService.handleError(error, 'DELETE VESSEL SERVICE')
      }
      return error.response.data
    })




     const response=await VesselService.deleteVessel(vessel_id);
     if(response.success){
       commit('removeVessel',vessel_id)
       return true;
     }
     return false;
  },

  async getVesselAccidentIncidentYearlyCounts({commit}, params) {
    const accidentIncidentYearlyCounts = await VesselService.getVesselAccidentIncidentYearlyCounts(params);
    if (accidentIncidentYearlyCounts){
      commit('setVesselAccidentIncidentYearlyCounts', accidentIncidentYearlyCounts.data)
      commit('setPagination',accidentIncidentYearlyCounts)
    }
  },

  async getVesselsWorkingEnvironment({commit}, params) {
    const accidentIncidentWorkingEnvironment = await VesselService.getVesselsWorkingEnvironment(params);

    if ('summary' in params) {
      commit('setVesselAccidentIncidentWorkingEnvironmentsSummary', accidentIncidentWorkingEnvironment)
    } else {
      if (accidentIncidentWorkingEnvironment){
        commit('setVesselAccidentIncidentWorkingEnvironments', accidentIncidentWorkingEnvironment.data)
        commit('setPagination',accidentIncidentWorkingEnvironment)
      }
    }
  },

  async getVesselsPscDeficiencies({commit}, params) {
    const pscInspectionDeficiencies = await VesselService.getVesselsPscDeficiencies(params);
      if (pscInspectionDeficiencies){
        commit('setPscInspectionDeficiencies', pscInspectionDeficiencies.data)
        commit('setPagination',pscInspectionDeficiencies)
      }
  },

  async getVesselsPscInspections({commit}, params) {
    const pscInspectionInspections = await VesselService.getVesselsPscInspections(params);
    if (pscInspectionInspections){
      commit('setPscInspectionInspections', pscInspectionInspections.data)
      commit('setPagination',pscInspectionInspections)
    }
  },

  async getVesselsRightshipInspections({commit}, params) {
    const rightshipInspectionInspections = await VesselService.getVesselsRightshipInspections(params);
    if (rightshipInspectionInspections){
      commit('setRightshipInspectionInspections', rightshipInspectionInspections.data)
      commit('setPagination',rightshipInspectionInspections)
    }
  },

  async getVesselAccidentIncidentYearlyCountsList({commit}, params) {
    const accidentIncidentYearlyCountsLists = await VesselService.getVesselAccidentIncidentListFromYearlyCount(params);
    if (accidentIncidentYearlyCountsLists){
      commit('setVesselAccidentIncidentYearlyCountsList', accidentIncidentYearlyCountsLists.data)
    }

  },
  async downloadVesselAuditReportStatusHistory({commit},params) {
    const response = await axios({
      url : DOWNLOAD_STATUS_HISTORY,
      method: 'POST',
      data : params,
      responseType: 'blob'
    });
    if (response.hasOwnProperty('status') && response.status === 200) {
      return response?.data ?? false;
    }
    return false;
  },
  async getAllVesselManningCompany({commit},params){
    const response = await VesselService.getAllVesselManningCompany()

    commit('setAllVesselManningCompany', response?.data?.data || [])
  }
}

const getters = {
  vesselManagement: state => state.vesselManagement,
  vesselTypeKeys: state => state.vesselTypeKeys,
  vesselKeys: state => DataService.capitalizeProperties(state.vesselKeys),
  vesselList: state => DataService.capitalizeProperties(state.vesselList),
  vessel: state => DataService.capitalizeProperties(state.vessel, ['vessel_image']),
  vesselInfo: state => DataService.capitalizeProperties(state.vesselInfo, ['vessel_image']),
  vesselAccidentIncidentYearlyCounts: state => state.vesselAccidentIncidentYearlyCounts,
  vesselAccidentIncidentYearlyCountsList: state => state.vesselAccidentIncidentYearlyCountsList,
  vesselAccidentIncidentWorkingEnvironments: state => state.vesselAccidentIncidentWorkingEnvironments,
  vesselAccidentIncidentWorkingEnvironmentsSummary: state => state.vesselAccidentIncidentWorkingEnvironmentsSummary,
  vesselSummaryList: state => state.vesselSummaryList,
  vesselPscInspectionDeficiencies: state => state.vesselPscInspectionDeficiencies,
  vesselPscInspectionInspections: state => state.vesselPscInspectionInspections,
  vesselManningCompanyList: state => state.vesselManningCompanyList,
  vesselRightshipInspectionInspections: state => state.vesselRightshipInspectionInspections,
  vesselsAuditSchedule: state => state.vesselsAuditSchedule,

}

export default {
  state,
  mutations,
  actions,
  getters
}
